import { statusTone } from "../lib/statuses";

const TONES = {
  success: "bg-[#EAF3EE] text-[#2C5545] border-[#3A7D5E]/30",
  danger: "bg-[#FBEDED] text-[#C44F4F] border-[#C44F4F]/30",
  warning: "bg-[#FDF6EA] text-[#B4791F] border-[#E89B31]/40",
  primary: "bg-[#EAF0ED] text-[#2C5545] border-[#2C5545]/30",
  muted: "bg-[#F4F2EC] text-[#515E58] border-[#E5E2DC]",
};

export function StatusBadge({ status, tone }) {
  const t = tone || statusTone(status);
  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${TONES[t] || TONES.muted}`}>
      {status}
    </span>
  );
}
